import React from "react";
import { Footer, Navbar } from "../../components";
import HeaderTentang from "./header/HeaderTentang";

const TentangGiliIyang = () => {
    return (
        <>
            <Navbar />
            <HeaderTentang />
            <Footer />
        </>
    )
}

export default TentangGiliIyang;